import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
import { tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

const STATE_KEY_PREFIX = 'http_requests:';

@Injectable()
export class TransferHttpResponseInterceptor implements HttpInterceptor {
  constructor(private transferState: TransferState, @Inject(PLATFORM_ID) private platformId: string) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Nothing to do with non-GET requests
    if (req.method !== 'GET') {
      return next.handle(req);
    }

    const key_serialized = makeStateKey<HttpResponse<object>>(
      Buffer.from(STATE_KEY_PREFIX + req.url).toString('base64')
    );

    if (isPlatformBrowser(this.platformId)) {
      if (this.transferState.hasKey(key_serialized)) {
        const cachedResponse = JSON.parse(
          Buffer.from(this.transferState.get(key_serialized, null), 'base64').toString('utf8')
        );
        if (cachedResponse) {
          this.transferState.remove(key_serialized); // cached response should be used only for the  first time
          return of(
            new HttpResponse({
              body: cachedResponse.body,
              status: 200
            })
          );
        }
      }
      return next.handle(req);
    } else {
      // in server, serialize and save response to be transferred to browser

      return next.handle(req).pipe(
        tap(event => {
          if (event instanceof HttpResponse && event.status === 200) {
            const response = {
              body: event.body
            };
            this.transferState.set(
              makeStateKey(key_serialized),
              Buffer.from(JSON.stringify(response)).toString('base64')
            );
          }
        })
      );
    }
  }
}
